import { ReminderMailBranchType } from '@/api'

export interface SendReminderMailRequest {
  dueDateFrom: string
  dueDateTo: string
  branchCodeFrom: string
  branchCodeTo: string
  branchType: ReminderMailBranchType
  hasReservationOnly: boolean
  sendFromBranchCode: string
  ids: string[]
  isUpdate: boolean
}

export function SendReminderMailRequestToJSON(
  value: SendReminderMailRequest
): any {
  return {
    due_date_from: value.dueDateFrom !== '' ? value.dueDateFrom : undefined,
    due_date_to: value.dueDateTo !== '' ? value.dueDateTo : undefined,
    branch_code_from:
      value.branchCodeFrom !== '' ? value.branchCodeFrom : undefined,
    branch_code_to: value.branchCodeTo !== '' ? value.branchCodeTo : undefined,
    branch_type: value.branchType ? value.branchType : undefined,
    has_reservation_only: value.hasReservationOnly ?? undefined,
    send_from_branch_code:
      value.sendFromBranchCode !== '' ? value.sendFromBranchCode : undefined,
    ids: value.ids.length > 0 ? value.ids : undefined,
    is_update: value.isUpdate ?? undefined
  }
}
